<template>
  <div class="flex items-center w-full gap-4" :class="{ 'justify-between': label }">
    <p
      v-if="label"
      class=""
      :class="[
        data ? '' : 'text-gray-400',
        light ? '  font-light tracking-wide text-base' : ' font-normal text-lg',
      ]">
      {{ label }}
    </p>
    <label
      :for="name"
      class="relative inline-block h-6 w-10 cursor-pointer [-webkit-tap-highlight-color:_transparent]">
      <input type="checkbox" :id="name" class="sr-only peer" v-model="data" :disabled="disable" />
      <span
        class="absolute inset-0 m-auto h-1.5 w-full bg-gray-300 rounded-full peer-checked:bg-theme-500"></span>
      <span
        class="absolute inset-y-0 w-4 h-4 m-auto transition-all bg-gray-300 rounded-full start-0 peer-checked:start-6 peer-checked:bg-theme-500">
      </span>
    </label>
  </div>
</template>

<script setup lang="ts">
const data = defineModel<boolean>();

withDefaults(
  defineProps<{
    label?: string;
    name: string;
    disable?: boolean;
    light?: boolean;
  }>(),
  {}
);
</script>
